export const SET_UI_THEME = 'SET_UI_THEME';

export const SET_USER_AUTH = 'SET_USER_AUTH';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_META_DATA = 'SET_META_DATA';
export const SET_CREATE_SUCCESS = 'SET_CREATE_SUCCESS';